<!-- Topbar Start -->
<header class="navbar-custom">
  <div class="page-grid--fluid">
    <ul class="list-unstyled topnav-menu float-right mb-0">
      <li
        class="li-area proposal"
        (mouseover)="addActive('newProposal')"
        (mouseout)="removeActive('newProposal')"
        (click)="modalNewPropose()"
      >
        <button class="btn-notifications b-0">
          <img src="assets/images/svg/wallet-add.svg" alt="icone da nova proposta" />
        </button>
        <div class="label-container actions" #labelProposal>
          <span>Nova Proposta</span>
        </div>
      </li>

      <li
        *ngIf="!!user.store"
        class="li-area store"
        (mouseover)="addActive('store')"
        (mouseout)="removeActive('store')"
        (click)="openStore()"
      >
        <button class="btn-notifications b-0">
          <i class="icon fg fg-vuesaxlinearShopshop"></i>
        </button>
        <div class="label-container" #labelStore>
          <span>Loja Digital</span>
        </div>
      </li>

      <li class="li-area" *ngIf="visibleUser()">
        <button class="btn-notifications b-0" matTooltip="Ajuda" matTooltipPosition="above" (click)="openPageHelper()">
          <i class="icon fn fn-vuesaxlinearEssetionalHelper"></i>
        </button>
      </li>

      <li
        *ngIf="roles == 'BUSINESS BANKER' ||  roles == 'CORBAN' || roles == 'PARTNER'"
        id="dropdown-bell"
        class="dropdown"
        ngbDropdown
        autoClose="outside"
      >
        <a
          class="dropdown-toggle waves-effect waves-light"
          ngbDropdownToggle
          role="button"
          (click)="clickNotifications()"
        >
          <button
            class="btn-notifications b-0"
            [matBadge]="numberOfNotifications.toString()"
            [matBadgeHidden]="hiddenBadge"
          >
            <i class="icon fg fg-vuesaxlinearNotificationsnotification"></i>
          </button>
        </a>
        <div class="dropdown-notifications dropdown-menu dropdown-menu-right py-3" ngbDropdownMenu>
          <div id="triangle"></div>
          <h3 style="text-align: center; font-size: 1.3rem; margin-left: -15px" class="text-orange pl-3 mt-0">
            Mensagens
          </h3>
          <div *ngIf="notificationsList$ | async as list; else loading">
            <div class="content-items" *ngIf="list.Items.length > 0; else noItems">
              <ul [ngClass]="{'scroll': statusShowAllNotifications}">
                <li *ngFor="let item of list.Items">
                  <a class="dropdown-item mt-0">
                    <div class="dropdown-notifications--item">
                      <div
                        *ngIf="!item.is_read"
                        class="dropdown-notifications--dot"
                        (click)="setReadAndRedirect(item.id, item.bitrix_id, item.is_read)"
                      ></div>
                      <i
                        class="dropdown-notifications--trash time fg fg-vuesaxlinearEssetionaltrash"
                        (click)="deleteNotification(item.id)"
                        alt="icone lixeira"
                      ></i>
                      <span
                        class="font-weight-bold d-block"
                        (click)="setReadAndRedirect(item.id, item.bitrix_id, item.is_read)"
                      >
                        {{item.content}}
                      </span>
                      <span
                        class="pt-2 d-block time"
                        (click)="setReadAndRedirect(item.id, item.bitrix_id, item.is_read)"
                      >
                        {{ item.created_at | dateNow : 'GMT -3' }}
                      </span>
                    </div>
                  </a>
                </li>
              </ul>
              <div *ngIf="!statusShowAllNotifications && (notificationsList$ | async)" class="w-100 text-center">
                <button *ngIf="notificationsList$" class="btn btn-dark mt-2 px-5 py-2" (click)="showAllNotifications()">
                  <strong>Ver Todas as Mensagens</strong>
                </button>
              </div>
            </div>
            <ng-template #noItems>
              <div class="no-item text-center">
                <h3 class="text-dark">Não Há Itens</h3>
              </div>
            </ng-template>
          </div>
          <ng-template #loading>
            <div class="no-item text-center" *ngIf="hasNotification === false">
              <h3 style="color: #2b2b2b; font-size: 18px; margin-top: 20px">Não Há Itens</h3>
            </div>

            <div style="width: 103px; padding: 50px 0; margin: auto" *ngIf="hasNotification !== false">
              <mat-spinner></mat-spinner>
            </div>
          </ng-template>
        </div>
      </li>
      <li class="topbar-title">
        <h3>{{user.name}}</h3>
        <p>{{rolesLabelEnum[user.roles]}}</p>
      </li>
      <div class="dropMenu">
        <img
          class="img-user"
          (click)="dropDown()"
          (window:mouseup)="autoCloseForDropdown($event)"
          *ngIf="user.href"
          height="40"
          src="{{user?.href}}"
          width="40"
          alt="imagem do perfil"
        />
        <div
          *ngIf="!user.href"
          (click)="dropDown()"
          (window:mouseup)="autoCloseForDropdown($event)"
          class="circle d-flex align-items-center justify-content-center"
        >
          <span class="text-white">{{nameCircle}}</span>
        </div>
        <div class="dropdown-menu" *ngIf="dropdown">
          <a class="dropdown-item" [routerLink]="['/profile']" (click)="dropDown()">
            <i class="fg fg-vuesaxlinearSettingssetting-2"></i>
            <span>Configurações</span>
          </a>
          <a class="dropdown-item" [routerLink]="['/terms-conditions']" (click)="dropDown()">
            <i class="fg fg-vuesaxlinearSecurityshield"></i>
            <span>Termos e condições</span>
          </a>
          <a class="dropdown-item logout" (click)="logout()">Log out</a>
        </div>
      </div>
      <div class="dropMenu">
        <i (click)="dropDown()" *ngIf="!dropdown" class="fg fg-vuesaxlinearArrowchevron-down" alt="" srcset=""></i>
        <i (click)="dropDown()" *ngIf="dropdown" class="fg fg-vuesaxlinearArrowchevron-up" alt="" srcset=""></i>
      </div>
    </ul>
  </div>
</header>
<!-- end Topbar -->
